module.exports = __webpack_public_path__ + "static/media/largo-retrocapital.153f04bd.png";